import classNames from 'classnames';
import * as React from 'react';

import {HtmlText} from './HtmlText';
import basePlainTextOrHtmlParams, {
  BasePlainTextOrHtmlParams,
} from 'src/js/common/raw_rendering/base_plain_text_or_html_params';

type OwnProps = BasePlainTextOrHtmlParams;

type Props = OwnProps;

export const PlainTextOrHtml: React.FC<Props> = (props) => {
  const {
    className = '',
    showHtml = false,
    text,
    title,
  } = basePlainTextOrHtmlParams(props);
  return showHtml ? (
    <HtmlText className={className} text={text} title={title} />
  ) : (
    <span className={classNames(className)} title={title}>
      {text}
    </span>
  );
};

PlainTextOrHtml.displayName = 'PlainTextOrHtml';
